import React, { useContext } from "react";
import { CartContext } from "../context/CartContext";
import { useNavigate } from "react-router-dom";

export default function Cart() {
  const { cart, addToCart, removeFromCart, setCart } = useContext(CartContext);
  const navigate = useNavigate();

  // decrease quantity or remove item if quantity becomes 0
  const decreaseQuantity = (id) => {
    const exist = cart.find(item => item.id === id);

    if (exist.quantity === 1) {
      removeFromCart(id);
    } else {
      setCart(
        cart.map(item =>
          item.id === id
            ? { ...item, quantity: item.quantity - 1 }
            : item
        )
      );
    }
  };

  // calculate totals
  const totalPrice = cart.reduce(
    (acc, item) => acc + item.price * item.quantity,
    0
  );

  const totalQuantity = cart.reduce(
    (acc, item) => acc + item.quantity,
    0
  );

  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h1 className="flex justify-center text-2xl font-bold mb-5">
        Your Cart
      </h1>

      {cart.length === 0 ? (
        <div className="text-center py-20">
          <img
            src="/assets/aiim.webp"
            className="mx-auto h-96 w-96"
            alt="Empty Cart"
          />

          <p className="text-gray-500 mt-4">Your cart is empty!</p>

          <button
            onClick={() => navigate("/women")}
            className="mt-4 bg-blue-500 text-white px-4 py-2 rounded"
          >
            Shop Now
          </button>
        </div>
      ) : (
        <>
          {cart.map(item => (
            <div
              key={item.id}
              className="flex flex-col sm:flex-row items-start sm:items-center border rounded p-4 mb-4 gap-4"
            >
              <div className="h-24 w-24 flex-shrink-0">
                <img
                  src={item.img}
                  alt={item.name}
                  className="h-full w-full object-contain"
                />
              </div>

              <div className="flex flex-col gap-1">
                <h2 className="font-semibold text-lg">{item.name}</h2>

                <p className="text-gray-700">Price: ₹{item.price}</p>

                <div className="flex items-center gap-2 mt-1">
                  <button
                    onClick={() => decreaseQuantity(item.id)}
                    className="px-2 bg-gray-300 rounded"
                  >
                    -
                  </button>

                  <span>{item.quantity}</span>

                  <button
                    onClick={() => addToCart(item)}
                    className="px-2 bg-gray-300 rounded"
                  >
                    +
                  </button>
                </div>

                <p className="font-semibold mt-1">
                  Subtotal: ₹{item.price * item.quantity}
                </p>
              </div>

              <button
                onClick={() => removeFromCart(item.id)}
                className="ml-auto bg-red-500 hover:bg-red-600 text-white px-3 py-1 rounded transition mt-2 sm:mt-0"
              >
                Remove
              </button>
            </div>
          ))}

          <div className="flex justify-end mb-4">
            <button
              onClick={() => setCart([])}
              className="bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded"
            >
              Clear Cart
            </button>
          </div>

          <div className="border-t pt-4 flex flex-col gap-2">
            <p className="text-lg font-semibold">
              Total Quantity: {totalQuantity}
            </p>

            <p className="text-lg font-semibold">
              Total Price: ₹{totalPrice}
            </p>
          </div>
        </>
      )}
    </div>
  );
}